import { render, staticRenderFns } from "./AboutVision.vue?vue&type=template&id=6a0edd2a&"
import script from "./AboutVision.vue?vue&type=script&lang=js&"
export * from "./AboutVision.vue?vue&type=script&lang=js&"
import style0 from "./AboutVision.vue?vue&type=style&index=0&id=6a0edd2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports